

























import { websiteText } from '@/mixins/websiteTexts';
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class EverydayHeroSearchbox extends Vue {
    currentTab: 'files' | 'products' = 'files';

    get formTargetUrl(): string {
        return this.currentTab === 'files' ? window.__litium.quickSearchUrl : window.__litium.centralSearchUrl;
    }
}
